import { ACTION_TYPES } from '~/core/constants'

const { FEATURE_FLAGS } = ACTION_TYPES

const initialState = {
  enableUpgradeToPro: true,
  autoCallIntoMeeting: true
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FEATURE_FLAGS.SET_FEATURE_FLAGS: {
      return {
        ...state,
        ...action.payload
      }
    }
    default:
      return state
  }
}

export default reducer
